



































import Vue from 'vue';
export default Vue.extend({
  computed: {
    isDisabled(): boolean {
      return this.readonly && !this.isFocused;
    },
  },
  data() {
    return {
      isFocused: false,
    };
  },
  name: 'SelectField',
  props: {
    id: {
      default: '',
      type: String,
    },
    label: {
      type: String,
    },
    name: {
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
    readonly: {
      default: false,
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    value: {
      default: '',
      type: String,
    },
  },
});
